"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.useAnalytics = exports.useAnalyticsEventScroll = exports.AnalyticsProvider = exports.exception = exports.OutboundLink = exports.outboundLink = exports.ga = exports.event = exports.modalview = exports.set = exports.pageview = exports.initialize = void 0;

var _reactGa = require("react-ga");

exports.initialize = _reactGa.initialize;
exports.pageview = _reactGa.pageview;
exports.set = _reactGa.set;
exports.modalview = _reactGa.modalview;
exports.event = _reactGa.event;
exports.ga = _reactGa.ga;
exports.outboundLink = _reactGa.outboundLink;
exports.OutboundLink = _reactGa.OutboundLink;
exports.exception = _reactGa.exception;

var _AnalyticsProvider = _interopRequireDefault(require("./AnalyticsProvider"));

exports.AnalyticsProvider = _AnalyticsProvider.default;

var _useAnalytics = require("./useAnalytics");

exports.useAnalytics = _useAnalytics.useAnalytics;

var _useAnalyticsEventScroll = _interopRequireDefault(require("./useAnalyticsEventScroll"));

exports.useAnalyticsEventScroll = _useAnalyticsEventScroll.default;